<div class="diagnostics-consent">
  <div class="diagnostics-consent__badge" aria-hidden="true">
    <ion-icon name="bug-outline"></ion-icon>
  </div>

  <h2 class="diagnostics-consent__title">
    {{ "MODALS.DIAGNOSTICS_CONSENT.TITLE" | translate }}
  </h2>
  <p class="diagnostics-consent__subtitle">
    {{ "MODALS.DIAGNOSTICS_CONSENT.SUBTITLE" | translate }}
  </p>

  <div class="diagnostics-consent__body">
    <p class="diagnostics-consent__intro">
      {{ "MODALS.DIAGNOSTICS_CONSENT.INTRO" | translate }}
    </p>

    <section class="diagnostics-consent__section">
      <h3 class="diagnostics-consent__section-title">
        {{ "MODALS.DIAGNOSTICS_CONSENT.WHY_TITLE" | translate }}
      </h3>
      <p class="diagnostics-consent__section-text">
        {{ "MODALS.DIAGNOSTICS_CONSENT.WHY_BODY" | translate }}
      </p>
    </section>

    <section
      *ngIf="supportReason"
      class="diagnostics-consent__support"
      role="note"
    >
      <span class="diagnostics-consent__support-label">
        {{ "MODALS.DIAGNOSTICS_CONSENT.SUPPORT_CONTEXT" | translate }}
      </span>
      <p class="diagnostics-consent__support-text">{{ supportReason }}</p>
    </section>

    <section class="diagnostics-consent__section">
      <h3 class="diagnostics-consent__section-title">
        {{ "MODALS.DIAGNOSTICS_CONSENT.SENT_TITLE" | translate }}
      </h3>
      <ul class="diagnostics-consent__list">
        <li>{{ "MODALS.DIAGNOSTICS_CONSENT.SENT_1" | translate }}</li>
        <li>{{ "MODALS.DIAGNOSTICS_CONSENT.SENT_2" | translate }}</li>
        <li>{{ "MODALS.DIAGNOSTICS_CONSENT.SENT_3" | translate }}</li>
      </ul>
    </section>

    <section class="diagnostics-consent__section">
      <h3 class="diagnostics-consent__section-title">
        {{ "MODALS.DIAGNOSTICS_CONSENT.THIRD_PARTY_TITLE" | translate }}
      </h3>
      <p class="diagnostics-consent__section-text">
        {{ "MODALS.DIAGNOSTICS_CONSENT.THIRD_PARTY_BODY" | translate }}
      </p>
    </section>

    <p class="diagnostics-consent__note">
      {{ "MODALS.DIAGNOSTICS_CONSENT.RETENTION" | translate }}
    </p>
    <p class="diagnostics-consent__note diagnostics-consent__note--control">
      {{ "MODALS.DIAGNOSTICS_CONSENT.CONTROL" | translate }}
    </p>
  </div>

  <div class="diagnostics-consent__actions">
    <button
      type="button"
      class="diagnostics-consent__btn diagnostics-consent__btn--secondary"
      (click)="decline()"
    >
      {{
        (variant === "settings"
          ? "MODALS.DIAGNOSTICS_CONSENT.CANCEL"
          : "MODALS.DIAGNOSTICS_CONSENT.DECLINE"
        ) | translate
      }}
    </button>
    <button
      type="button"
      class="diagnostics-consent__btn diagnostics-consent__btn--primary"
      (click)="accept()"
    >
      {{
        (variant === "settings"
          ? "MODALS.DIAGNOSTICS_CONSENT.ACTIVATE"
          : "MODALS.DIAGNOSTICS_CONSENT.ACCEPT"
        ) | translate
      }}
    </button>
  </div>
</div>
